import { render, staticRenderFns } from "./happy-space.vue?vue&type=template&id=e8a9006e&scoped=true&"
import script from "./happy-space.vue?vue&type=script&lang=js&"
export * from "./happy-space.vue?vue&type=script&lang=js&"
import style0 from "./happy-space.vue?vue&type=style&index=0&id=e8a9006e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a9006e",
  null
  
)

export default component.exports